



















































































































































































































































import Vue from "vue";
import { computed, ref, onMounted, Ref, watch } from "@vue/composition-api";
import { CmsPricingPlan } from "@/common/state/cms/cms.models";
import { AppAnalytics } from "@/analytics";
import { UseModal } from "@/components/root/modal";
import hubspotModal from "./hubspotModal.vue";
import { UseToast, ToastType } from "@/components/root/toast/toast.state";
import { getTotalAccountsCount } from "@/views/accounts/data/api";
import { SharedState } from "@/common/state";
import { PricePerSize } from "@/common/state/cms/cms.models";
import { ThirdPartyModal } from "@/components/root/third-party/thirdParty.modal";
import { isNotEmpty } from "@/fp";
type LeftSectionViewOption = "main" | "meeting" | "phone_call" | "send_email";

declare const hbspt: any;

export default Vue.extend({
  // components: { SendEmail, PhoneCall, HubspotModal },
  props: {
    plan: {
      type: Object,
    },
  },
  setup(props) {
    const show_conformation_options = ref(false);

    const number_of_seats = ref(0);

    onMounted(async () => {
      number_of_seats.value = await getTotalAccountsCount();
    });

    const the_plan = computed(() => props.plan as CmsPricingPlan);

    const is_youtube_vid = computed(
      () =>
        isNotEmpty(the_plan.value.video_url) &&
        the_plan.value.video_url.search("youtube") > -1
    );

    const is_loading_price = ref(false);
    const the_price = ref(0);

    const is_in_range = (min: number, max: number, size: number) => {
      return (size >= min && size < max) || (size > min && size <= max);
    };

    const get_price_per_for_range = (size: number, prices: PricePerSize) => {
      for (const { price, min, max } of prices.price_per_size) {
        if (is_in_range(min, max, size)) {
          return price;
        }
      }
      return prices.price_per_size[prices.price_per_size.length - 1].price;
    };

    const calc_price = async () => {
      if (the_plan.value.price.type === "size") {
        const org_size: number = await SharedState.get_org_size();
        return get_price_per_for_range(org_size, the_plan.value.price);
      } else {
        return the_plan.value.price.price_per_seat;
      }
    };

    const ok_btn_text = computed(() => {
      const { cta_type } = the_plan.value;
      switch (cta_type) {
        case "upgrade":
        case "contact":
          return "Upgrade";
        case "demo":
        default:
          return "book a demo";
      }
    });

    onMounted(() => {
      is_loading_price.value = true;
      calc_price().then((val) => {
        the_price.value = val;
        is_loading_price.value = false;
      });
      watch(the_plan, (new_plan, old_plan) => {
        if (new_plan && old_plan && new_plan.id !== old_plan.id) {
          // clear
          left_section.value = "main";
          show_conformation_options.value = false;
        }
      });
    });

    const submit = () => {
      const { cta_type } = the_plan.value;
      switch (cta_type) {
        case "contact":
          get_in_touch();
          break;
        case "upgrade":
          //  UseModal().show(PaymentModal, { plan: props.plan });
          break;
        case "demo":
        default:
          open_hubspot_calendar();
          break;
      }
    };

    const get_in_touch = () => {
      show_conformation_options.value = true;
    };

    const close_contact_section = () => {
      left_section.value = "main";
      show_conformation_options.value = false;
    };

    const open_hubspot_calendar = () => {
      UseModal().show(hubspotModal);
      show_conformation_options.value = false;
    };

    const receive_a_call = async (phone_num: string) => {
      AppAnalytics.report({
        component: "Upgrade",
        eventName: `get_in_touch`,
        payload: {
          number_of_seats: number_of_seats.value,
          plan: the_plan.value.id,
          phone: phone_num,
          via: "call",
        },
      });
      UseToast().show({
        type: ToastType.SUCCESS,
        msg: "Great! we will contact you ASAP",
        duration: 5000,
      });
      close_contact_section();
    };

    const send_email_to_sales = async (payload: {
      body: string;
      subject: string;
    }) => {
      const { body, subject } = payload;
      AppAnalytics.report({
        component: "Upgrade",
        eventName: "get_in_touch",
        payload: {
          number_of_seats: number_of_seats.value,
          plan: the_plan.value.id,
          via: "email",
          subject,
          body,
        },
      });
      UseToast().show({
        type: ToastType.SUCCESS,
        msg: "Great! we will contact you ASAP",
        duration: 5000,
      });
      close_contact_section();
    };

    const schedule_meeting = () => {
      const plan = props.plan as CmsPricingPlan;
      open_hubspot_calendar();
      AppAnalytics.report({
        component: "Upgrade",
        eventName: "get_in_touch",
        payload: {
          number_of_seats: number_of_seats.value,
          plan: plan.id,
          via: "meeting",
        },
      });
      close_contact_section();
    };

    /*    const edition_not_high_enough = computed(() => {
      const { min_edition: plan_min_edition } = props.plan as CmsPricingPlan;
      const {
        name: user_edition
      } = SharedState.loggedUser.value.paymentEdition;
      return editionToNumber(plan_min_edition) > editionToNumber(user_edition);
    }); */

    // main , meeting , phone_call ,send_email
    const left_section: Ref<LeftSectionViewOption> = ref("main");
    const contact_us_title = computed(() => {
      switch (left_section.value) {
        case "meeting":
          return "Schedule a meeting (using hubspot)";
        case "phone_call":
          return "What's your number?";
        case "send_email":
          return "Send an email";
        case "main":
        default:
          return "";
      }
    });

    const open_hubspot_meetings_modal = () => {
      // "https://meetings.hubspot.com/cognni",
      ThirdPartyModal.show({
        // @ts-ignore
        link: the_plan.value.contact.meeting,
        width: "70rem",
        height: "54rem",
      });
    };

    const open_hubspot_email_modal = () => {
      //"https://share.hsforms.com/1m-JtrhCiTvulTNiBvZ6raA1zdos",
      ThirdPartyModal.show({
        link: the_plan.value.contact.email,
        width: "60rem",
        height: "37rem",
      });
    };
    const open_hubspot_phone_modal = () => {
      //"https://share.hsforms.com/1thv8K_ulT7CJomcHZlgT1g1zdos",
      ThirdPartyModal.show({
        // @ts-ignore
        link: the_plan.value.contact.phone,
        width: "60rem",
        height: "37rem",
      });
    };
    return {
      is_loading_price,
      the_price,
      ok_btn_text,
      submit,
      show_conformation_options,
      open_hubspot_calendar,
      receive_a_call,
      send_email_to_sales,
      schedule_meeting,
      left_section,
      contact_us_title,
      open_hubspot_email_modal,
      open_hubspot_phone_modal,
      open_hubspot_meetings_modal,
      is_youtube_vid,
    };
  },
});
